import { Panels } from "@msuite/ui/panels";
import Notes from "@/components/notes";
import type { ProtocolPanelBaseProps } from "../shared";
import { ProtocolContent } from "./protocol-content";
import { ProtocolEmails } from "./protocol-emails";
import { ProtocolInformation } from "./protocol-information";
import { ProtocolInvolvements } from "./protocol-involvements";

export function ProtocolGeneral({ protocolId }: ProtocolPanelBaseProps) {
	/** Render */
	return (
		<Panels>
			<Panels.Panel
				flex={2}
				className="bottom-space"
			>
				<ProtocolContent protocolId={protocolId} />
			</Panels.Panel>
			<Panels.Panel
				flex={1}
				className="bottom-space"
			>
				<ProtocolInformation protocolId={protocolId} />
				<ProtocolInvolvements protocolId={protocolId} />
				<ProtocolEmails protocolId={protocolId} />
				<Notes
					notesTable="protocolNotes"
					identifier={protocolId}
				/>
			</Panels.Panel>
		</Panels>
	);
}
